import apiClient from "./apiClient";

export const getAppointmentStatuses = (id) => apiClient.get(`/appointments/statuses`);

export const getAppointmentsByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/appointments/pet/${id}`, { params: { page, limit } })
    .then(res => res);
export const getUpcomingAppointments = (page = 1, limit = 30) => apiClient
    .get(`/appointments/upcoming`, { params: { page, limit } })
    .then(res => res);
export const getAppointmentsCalendar = (page = 1, limit = 30) => apiClient
    .get(`/appointments/calendar`, { params: { page, limit } })
    .then(res => res);
export const getAppointmentsByDate = (date, page = 1, limit = 30) => apiClient
    .get(`/appointments/calendar/date/${date}`, { params: { page, limit } })
    .then(res => res);
export const getUpcomingAppointmentsByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/appointments/pet/${id}/upcoming`, { params: { page, limit } })
    .then(res => res);
export const getAppointmentsByPetOwnerId = (id, page = 1, limit = 30) => apiClient
    .get(`/appointments/pet-owner/${id}`, { params: { page, limit } })
    .then(res => res);
export const getAppointmentsByHistorytId = (id, page = 1, limit = 30) => apiClient
    .get(`/appointments/history/${id}`, { params: { page, limit } })
    .then(res => res);
export const getAppointmentsByHistoryEntrytId = (id, page = 1, limit = 30) => apiClient
    .get(`/appointments/history-entry/${id}`, { params: { page, limit } })
    .then(res => res);
export const getAppointmentById = (id) => apiClient.get(`/appointments/${id}`);
export const createAppointment = (data) => apiClient.post("/appointments", data);
export const updateAppointment = (id, data) => apiClient.put(`/appointments/${id}`, data);
export const deleteAppointment = (id) => apiClient.delete(`/appointments/${id}`);
export const confirmAppointment = (referenceCode) => apiClient.post(`/appointments/confirm/${referenceCode}`);